module.exports = __webpack_public_path__ + "img/hg.8bc6366d.png";